import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { toPublicAppUrl } from '../public-app-url';

export interface BiddingLinkDialogData {
  bidding_link: string;
  boq_code: string;
  boq_name: string;
}

@Component({
  selector: 'app-bidding-link-dialog',
  templateUrl: './bidding-link-dialog.component.html',
  styleUrls: ['./bidding-link-dialog.component.css']
})
export class BiddingLinkDialogComponent {
  biddingLink: string;

  constructor(
    private toastr: ToastrMsgService,
    public dialogRef: MatDialogRef<BiddingLinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BiddingLinkDialogData
  ) {
    this.biddingLink = toPublicAppUrl(data.bidding_link);
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.biddingLink).then(() => {
      this.toastr.success('Bidding link copied to clipboard');
    }).catch(() => {
      this.toastr.error('Failed to copy link');
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
